<ng-template #buttons>
    @if (store.isAllowed('folderMail.create')() && !store.isTerminated()) {
        <app-button
            label="service.mailRecords.direction.outgoing"
            icon="pi-plus"
            (clickEvent)="createServiceMailRecord('outgoing')">
        </app-button>
        <app-button
            label="service.mailRecords.direction.incoming"
            icon="pi-plus"
            (clickEvent)="createServiceMailRecord('incoming')">
        </app-button>
    }
</ng-template>

<app-table
    [gridData]="$any(store.data.getServiceMails())"
    [columns]="columns()"
    translatePrefix="service.mailRecords."
    [showSearch]="true"
    [showColumnVisiblity]="true"
    [showExport]="true"
    [showClearFilter]="true"
    [buttons]="buttons"
    scrollHeight="flex"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getServiceMails"
    [refreshCallbackFragment]="getMailsFrag"
    (detailCallback)="editServiceMailRecord($event)"
    (deleteCallbackWithEvent)="deleteServiceMailRecord($event)"
    [showDetail]="store.isAllowed('folderMail.update')()"
    [showDelete]="store.isAllowed('folderMail.delete')()"
    [defaultSorters]="[{ column: 'date', direction: 'DESC' }]"
>
    <ng-template pTemplate="users" let-data="data">
        <div class="flex flex-column gap-small">
            @for (user of data; track user.id) {
                <app-user-chip
                    [user]="user"
                ></app-user-chip>
            }
        </div>
    </ng-template>

</app-table>
